import { getAppSearchParams } from './utils';

// network statuses
export const REQUEST = 'REQUEST';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';

export const PARAM_DEFAULTS = getAppSearchParams();
